import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, ThemeProvider, createTheme, Tooltip  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import { teams } from '../../assets/staticData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import DateSelector from '../DateSelector';
import YearSelector from '../YearSelector';
import { formatDate, isEmpty } from '../../common/StaticExports';
import { useTranslation } from 'react-i18next';
import { deleteAcademyPeriod } from '../../api/dataCapture';
import { useSelector } from 'react-redux';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const PeriodTable = (props?: any) => {
    const { data, addData, handleClick, updateList } = props;
    const [newData, setNewData]:any = React.useState({});
    const [t] = useTranslation();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data && data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {key: '', displayName: t('DC_8_FROM')},
    {key: '', displayName: t('DC_8_TO')},
    {key: '', displayName: ''},
  ]

  const updateData = (row:any) => {
    const updatedList = data?.map((d:any) => d?.id == row?.id ? row : d);
    updateList(updatedList);
  }

  const manageDeleteRow = (row: any) => {
    if(row?.id) {
      deleteAcademyPeriod({ clubId: clubDetails?.id, id: row?.id });
    }
    const updatedList = data?.filter((d:any) => d?.id != row?.id || d?.tempId != row?.tempId);
    updateList(updatedList);
  }

  const manageCreatenew = () => {
    if (newData?.club) {
      const updatedList = [{...newData, tempId: Math.random}, ...data];
      updateList(updatedList);
      setNewData({});
      handleClick();
    }
  }
  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '190px', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                      {
                        !isAdmin &&
                        addData &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-add-data`}
                        >
                            <TableCell className='fs12'>
                              <DateSelector variant={'standard'} dateValue={newData?.dateFrom ? formatDate(newData?.dateFrom) : null} manageChange={(e:any) => {updateData({...newData, dateFrom: e})}}  isError={isEmpty(newData?.dateFrom)} errorMessage={t('REQUIRED')} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <DateSelector variant={'standard'} dateValue={newData?.dateTo ? formatDate(newData?.dateTo) : null} manageChange={(e:any) => {updateData({...newData, dateTo: e})}}/>
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                              <DateSelector variant={'standard'} dateValue={d?.dateFrom ? formatDate(d?.dateFrom) : null} manageChange={(e:any) => {updateData({...d, dateFrom: e})}}  isError={isEmpty(d?.dateFrom) && !isAdmin} errorMessage={t('REQUIRED')}  disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <DateSelector variant={'standard'} dateValue={d?.dateTo ? formatDate(d?.dateTo) : null} manageChange={(e:any) => {updateData({...d, dateTo: e})}} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {!isAdmin && manageDeleteRow(d)}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default PeriodTable;